import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import * as PhosphorIcons from '@phosphor-icons/react';

const { ArrowLeft, MusicNotes, EnvelopeSimple } = PhosphorIcons;

const LegalShell = ({ title, lastUpdated, children }) => {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-black text-white">
      <div className="max-w-4xl mx-auto px-6 py-12">
        <div className="flex items-center justify-between mb-8">
          <Button onClick={() => navigate('/')} className="bg-zinc-900 hover:bg-zinc-800 text-zinc-300 border border-zinc-800" data-testid="back-to-home">
            <ArrowLeft size={18} className="mr-2" />Home
          </Button>
          <div className="flex items-center gap-2 text-blue-400">
            <MusicNotes size={22} weight="bold" />
            <span className="font-bold tracking-tight">MusicSync</span>
          </div>
        </div>

        <h1 className="text-4xl sm:text-5xl font-bold tracking-tight mb-2">{title}</h1>
        <p className="text-sm text-zinc-500 font-mono uppercase tracking-wider mb-10">Last updated: {lastUpdated}</p>

        <div className="prose prose-invert max-w-none prose-headings:text-white prose-headings:tracking-tight prose-p:text-zinc-300 prose-li:text-zinc-300 prose-a:text-blue-400 prose-strong:text-white prose-h2:mt-10 prose-h2:mb-4 prose-h2:text-2xl prose-h3:mt-6 prose-h3:mb-3 prose-h3:text-lg">
          {children}
        </div>

        <footer className="mt-16 pt-6 border-t border-zinc-800 text-center text-sm text-zinc-500">
          <p className="flex items-center justify-center gap-2">
            <EnvelopeSimple size={14} />
            <a href="mailto:admin@musicsync.net" className="hover:text-blue-400">admin@musicsync.net</a>
          </p>
          <p className="mt-2 text-xs">© 2026 MusicSync. All rights reserved.</p>
        </footer>
      </div>
    </div>
  );
};

export default LegalShell;
